import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    styleOverrides: {
        root: {
            svg: {
                fill: theme.palette.common.white,
            },
        },
    },
})
